import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateCityForm from '../../../modules/cities/components/CreateCityForm';
import { useParams } from 'react-router-dom';

const CreateCity = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const title = id ? t('edit_city') : t('create_city');
  dispatch(
    setBreadCrumbsData({
      page_title: title
    })
  );

  return (
    <div>
      <CreateCityForm />
    </div>
  );
};

export default CreateCity;
